import { useQuery } from '@tanstack/react-query'
import { RefreshCw } from 'lucide-react'
import { ADMIN_API_BASE_URL, Button, Skeleton } from '../../core/index.js'
import { ScheduleRunReadOnly } from '../../schedule/index.js'
import { getSchedulePeriod, getScheduleRun, type PartnerSession } from '../lib/partnerApi.js'
import { ErrorNote, describeError } from './formControls.js'

/**
 * Plays a partner's scheduler reading the month autonoME built: where the
 * month stands (`GET /facilities/{facilityId}/schedule/period`) and the
 * released run in full, which is what the scheduler would take as the
 * month. A partner reads; staff build and release from the Dashboard's Month tab.
 */
export function ScheduleRunsView({ session, facilityId }: { session: PartnerSession; facilityId: string }) {
  const periodQuery = useQuery({
    queryKey: ['partner-simulator', 'schedule-period', session.clientId, facilityId],
    queryFn: () => getSchedulePeriod(ADMIN_API_BASE_URL ?? '', session, facilityId),
    enabled: Boolean(ADMIN_API_BASE_URL),
  })
  const shown = periodQuery.data?.releasedRun ?? periodQuery.data?.latestRun ?? null
  const runQuery = useQuery({
    queryKey: ['partner-simulator', 'schedule-run', session.clientId, facilityId, shown?.runId ?? null],
    queryFn: () => getScheduleRun(ADMIN_API_BASE_URL ?? '', session, facilityId, shown?.runId as string),
    enabled: Boolean(ADMIN_API_BASE_URL) && shown !== null,
  })
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs text-ink-mid">The facility's month as a partner's scheduler reads it: the timeline from the facility's rules, and the released run - every worker's shifts, what they asked for and lost, and the contests settled by tier, score and seniority.</p>
        <Button icon={RefreshCw} variant="secondary" size="sm" disabled={periodQuery.isFetching} onClick={() => void Promise.all([periodQuery.refetch(), runQuery.refetch()])}>
          Refresh
        </Button>
      </div>
      {periodQuery.isPending ? <Skeleton /> : periodQuery.isError ? <ErrorNote message={describeError(periodQuery.error, 'The month could not be read.')} onRetry={() => void periodQuery.refetch()} retrying={periodQuery.isFetching} /> : <ScheduleRunReadOnly view={periodQuery.data} run={runQuery.data ?? null} />}
    </div>
  )
}
